import ScrollMagic from 'scrollmagic';

$(() => {

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-technologies-omnichinality',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.l-technologies-omnichinality .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-technologies-risks',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-technologies-risks .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-technologies-loyalty',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-technologies-loyalty .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-technologies-balancing',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-technologies-balancing .js-animate', 'js-animate-loaded')
    .addTo(controller);


    new ScrollMagic.Scene({
        triggerElement: '.l-technologies-features',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-technologies-features .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-technologies-types',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-technologies-types .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);

});



// WEBPACK FOOTER //
// ./app/scripts/pages/technologies/index.js